import React, { forwardRef } from 'react';

import type { FilterPopoverProps } from '@vlabs/monokit/shared/ui/popovers/filter-popover';
import { FilterPopover } from '@vlabs/monokit/shared/ui/popovers/filter-popover';
import { Control } from '@vlabs/uikit';
import { useFormContext } from 'react-hook-form';

import { useSearchPageTranslation } from '../../../../i18n';

function ComparingAttributeFilterPopover(
  {
    ...props
  }: FilterPopoverProps<string>,
  ref: React.ForwardedRef<HTMLDivElement>,
) {
  const { t } = useSearchPageTranslation();
  const { register } = useFormContext();

  return (
    <FilterPopover
      {...props}
      name="top_matching_candidates_label"
      ref={ref}
      title={<div className="Body-2">{t('filters.event_filters.comparing_attributes.comparing_attribute')}</div>}
    >
      <Control.Input
        {...register('top_matching_candidates_label')}
        id="top_matching_candidates_label"
      />
    </FilterPopover>
  );
}

const ComparingAttributeFilterPopoverWithRef = forwardRef(ComparingAttributeFilterPopover);
export { ComparingAttributeFilterPopoverWithRef as ComparingAttributeFilterPopover };
